import { cn } from "@/lib/utils";

const SIZES = {
  sm: { mark: "size-6", word: "h-3" },
  md: { mark: "size-8", word: "h-3.5" },
  lg: { mark: "size-9", word: "h-[18px]" },
} as const;

/**
 * The Taskpart logo: the full-colour puzzle mark and the TASKPART wordmark.
 * The wordmark is drawn through a mask so it keeps the brand blue on the light
 * theme and switches to ink on the dark canvas, where the blue would be too dim.
 */
export default function BrandMark({
  showWordmark = true,
  size = "md",
  className,
}: {
  showWordmark?: boolean;
  size?: keyof typeof SIZES;
  className?: string;
}) {
  const s = SIZES[size];
  return (
    <span
      role="img"
      aria-label="Taskpart"
      className={cn("flex min-w-0 shrink-0 items-center gap-2", className)}
    >
      <img src="/logo-mark.png" alt="" className={cn(s.mark, "shrink-0 object-contain")} />
      {showWordmark && (
        <span
          aria-hidden
          className={cn(
            s.word,
            "aspect-[228/30] shrink-0 bg-[#1d58b0] dark:bg-foreground",
            "[mask-image:url(/logo-wordmark.png)] [mask-size:contain] [mask-repeat:no-repeat] [mask-position:left_center]",
          )}
        />
      )}
    </span>
  );
}
